import {defineStore} from 'pinia';
import dfunctions from "../helpers/dfunctions"
import ddate from "../helpers/ddate"

const API_TRANSLATIONS_URL = process.env.VUE_APP_API_TRANSLATIONS_URL;
var project_name = process.env.VUE_APP_PROJECT_NAME;
const language_localstorage_key = project_name + "_dtranslations_data";
const loadedLanguage = localStorage.getItem(language_localstorage_key) || "sv";


export const useTranslationsStore = defineStore("dtranslations", {   
    state: () => ({
        enabled: true, // översättningar på/av
        fallback: false, // false för av eller language code    
        languages: [{ name: "Svenska", eng_name: "Swedish", code: "sv" }],
        loaded: false,
        loading: false,
        translationFiles: [ "demo" ],
        translationData: null,
        language: loadedLanguage,
    }),
   
    actions:{
        setLanguage(code)
        {        
           this.language = code;
           localStorage.setItem(language_localstorage_key, code);
           ddate.setLocale(code);
        },
        getLanguage()
        {
            return this.language;
        },
        getLanguageItem(code){            
            for(var i = 0; i < this.languages.length; i++)
            {
                if(this.languages[i].code == code)
                    return this.languages[i];
            }
            return null;
        },
        getTranslations()
        {
            return this.translationData
        },
        getFallback(){
            return this.fallback;
        },
        // { key, value} ex translate key = swish_pay => Betala faktura {{F_NR}} replace_list = { F_NR: 6373}
        translate(key, replace_list) 
        {
            var translated = key;
            var language = this.getLanguage();
            var translations = this.getTranslations();
    
            if (!this.enabled)
            {
                this.printconsole(key, translated, language);
                return translated;
            }       
    
            if (translations && translations[ key ] && translations[ key ][ language ])
            {
                translated = this.formatString(translations[ key ][ language ], replace_list);            
                this.printconsole(key, translated, language);
                return translated;
            }
            else if(this.fallback){
                var fallback = this.getFallback();
                if (translations && translations[ key ] && translations[ key ][ fallback ])
            {
                translated = this.formatString(translations[ key ][ fallback ], replace_list);            
                this.printconsole(key, translated, fallback);
                return translated;
            }
            }
    
            this.printconsole(key, translated, language);
            return key;
        },
        printconsole(key, value, language)
        {       
            var enabled = " [Translations: " + (this.enabled ? "ON" : "OFF") + "]";
            var languagetext = this.getLanguage().toUpperCase();
            if (key == value && this.enabled)
                dfunctions.printerror("[Translations("+languagetext+")]: Key '" + key + "' was not found!" + enabled);
            else       
            {
                // om fallback
                if(language == this.getLanguage()) 
                    dfunctions.printlog("[Translations("+languagetext+")]: Key '" + key + "' was translated into '" + value + "'" + enabled);
                else 
                    dfunctions.printerror("[Translations("+languagetext+")("+language.toUpperCase()+")]: Key '" + key + "' was translated into '" + value + "'" + enabled);
            }   
        },   
        getLanguages()
        {
            return this.languages;
        },
        formatString(str, replace_list) {
            if (!replace_list)
                return str;
        
            for (const key in replace_list) {
                const pattern = new RegExp(`{{${key}}}`, 'g');
                str = str.replace(pattern, replace_list[key]);
            }
            return str;
        },
        async fetchTranslationsData(force_refetch)
        {
            if(this.loaded && !force_refetch)
                return;
            this.loading = true;
            var post_data = {
                Translations: this.translationFiles
            };
    
            var url = API_TRANSLATIONS_URL + "gettranslationdata";
            var response = await fetch(url, { method: 'POST', body: JSON.stringify(post_data) });
            var json = await response.json();
            this.translationData = json.Data ?? {};
            this.loaded = true;
            this.loading = false;
        }
    }
})